<template>
    <div class="scc-content-box" :class="classes">
        <div class="scc-content-box__icon-container">
            <img v-if="icon" :src="icon" alt="icon" class="scc-content-box__icon" />
            <p v-if="title && type === 'row'" class="scc-content-box__title h4">{{ title }}</p>
        </div>
        <div class="scc-content-box__text-container">
            <p v-if="title && type === 'column'" class="scc-content-box__title h4">{{ title }}</p>
            <p v-if="text" class="scc-content-box__text">{{ text }}</p>
        </div>
    </div>
</template>

<script>
import './content-box.scss';

export default {
    name: 'ContentBox',
    __editor: {
        fields: {
            type: {
                widget: 'select',
                values: ['column', 'row'],
            },
            border: {
                widget: 'select',
                values: ['none', 'left', 'bottom'],
            },
            icon: {
                widget: 'media',
            },
            text: {
                widget: 'textarea',
            },
            backgroundColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'white'],
            },
            margin: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large'],
            },
        },
    },
    props: {
        type: {
            type: String,
            default: 'column',
            validator: function(val) {
                return ['column', 'row'].includes(val);
            },
        },
        border: {
            type: String,
            default: 'none',
            validator: function(val) {
                return ['none', 'left', 'bottom'].includes(val);
            },
        },
        title: String,
        icon: String,
        text: String,
        backgroundColor: {
            type: String,
            required: false,
            default: 'primary',
            validator: function(val) {
                return ['primary', 'secondary', 'body', 'white'].includes(val);
            },
        },
        margin: {
            type: String,
            default: 'none',
        },
    },
    computed: {
        classes() {
            return [
                [
                    `scc-content-box--${this.backgroundColor}`,
                    `scc-content-box--margin-${this.margin}`,
                    `scc-content-box--border-${this.border}`,
                ],
            ];
        },
    },
};
</script>
